import React from "react";

const DropDown = ({ additionalClass, icon, innerText }) => {
  return (
    <div
      className={`${additionalClass} pl-[10px] pr-[10px] bg-[#F8F9FF] rounded-[5.7px] cursor-pointer w-fit flex gap-3 items-center`}
    >
      <p className="text-[#262F59]">{innerText}</p>
      {icon}
    </div>
  );
};

export default DropDown;
